import React from 'react';
import { Currency, Col, Row, styled, ThemeProps } from '@teko/ds-mobile';
import { EditOutlined } from '@teko/ds-icon';
import { useFormatNumber } from 'hooks';

interface ProductPriceProps {
  price: number;

  // check if edit button can be shown, based on Cart's data
  editable?: boolean;
  onEditPrice?: () => void;

  // check if users can actually click edit button, based on each Item's data
  disableEditItemPrice?: boolean;
  strikeThroughDisplayPrice?: string;
  isDesktop?: boolean;
}

const Price = styled(Currency)(
  () => `
    font-size: 1rem;
    font-weight: bold;
  `,
);

const StrikeThroughPrice = styled.span(
  ({ theme }: ThemeProps) => `
  text-decoration: line-through;
  color: ${theme?.colors.textSecondary};
  font-size: 0.75rem;
`,
);

const StyledEditOutlined = styled(EditOutlined)(
  ({ theme }: ThemeProps) => `
  color: ${theme?.colors.link500};
  &.is-disabled {
    opacity: 0.5;
    color: ${theme?.colors.textSecondary}
  }
`,
);

export const ProductPrice: React.FunctionComponent<ProductPriceProps> = ({
  price,
  editable = false,
  onEditPrice,
  disableEditItemPrice = false,
  strikeThroughDisplayPrice,
  isDesktop,
}: ProductPriceProps) => {
  const formatNumber = useFormatNumber();
  return (
    <Col>
      {price >= 0 && (
        <Row align="middle" {...(isDesktop && { justify: 'end' })}>
          <Price
            value={price}
            formattedValue={formatNumber(price)}
            className="product-price__price"
          />
          {editable && (
            <StyledEditOutlined
              size={22}
              className={disableEditItemPrice ? 'is-disabled' : ''}
              {...(disableEditItemPrice ? {} : { onClick: onEditPrice })}
            />
          )}
        </Row>
      )}
      {!!strikeThroughDisplayPrice && (
        <Row align="middle" {...(isDesktop && { justify: 'end' })}>
          <StrikeThroughPrice className="product-price__listed-price att-strike-through-display-price">
            {strikeThroughDisplayPrice}
          </StrikeThroughPrice>
        </Row>
      )}
    </Col>
  );
};
